export const PAGES_WITH_DRIVER_PAY = [
  "/deliveries/orders",
  "/office/sales",
  "/deliveries/fleet",
];

export const PAGES_WITH_CUSTOM_PRICING = [
  "/deliveries/orders",
  "/office/sales",
];
